export enum QuoteTemplate {
  ISSUE_TYPE = 'issueType',
  FIXED_INCOME = 'fixedIncome',
  NO_PERMISSION = 'noPermission',
  UNKNOWN_SYMBOL = 'unknownSymbol',
  ERROR_MESSAGE = 'errorMessage',
  INVALID_SYMBOL = 'invalidSymbol'
}
